import { create } from "zustand";
import { preloadActiveGame } from "../games/preload";
import {
  initBaseAssets,
  initOtherSkins,
  initStartupAssets,
} from "../pixi/startupAssets";

/** Минимальная длительность показа лоадера, чтобы он не мигал. */
const MIN_LOADING_MS = 1000;

export type AssetsPhase = "idle" | "loading" | "ready" | "error";

interface AssetsState {
  phase: AssetsPhase;
  /** Прогресс основной фазы загрузки, 0..1. */
  progress: number;
  isReady: boolean;
  /** Идемпотентный запуск прогрева. Вызывается на входе в приложение. */
  start: () => void;
}

export const useAssetsStore = create<AssetsState>((set, get) => ({
  phase: "idle",
  progress: 0,
  isReady: false,

  start: () => {
    if (get().phase !== "idle") return;
    set({ phase: "loading", progress: 0 });

    const run = async () => {
      try {
        const minDurationPromise = new Promise((resolve) =>
          setTimeout(resolve, MIN_LOADING_MS)
        );

        await Promise.all([
          initStartupAssets((progress) => set({ progress })),
          preloadActiveGame(),
          minDurationPromise,
        ]);

        set({ phase: "ready", progress: 1, isReady: true });

        // Вторичные ассеты греются в фоне — игра уже играбельна.
        void initBaseAssets();
        initOtherSkins();
      } catch (error) {
        console.error("assetsStore: startup assets failed", error);
        // Не блокируем вход: игра догрузит недостающее через хуки.
        set({ phase: "error", progress: 1, isReady: true });
      }
    };

    void run();
  },
}));
